<div class="row justify-content-center" [ngClass]="showAlert == true ? 'd-flex' : 'd-none'">
   <div class="col-12 d-flex align-items-center justify-content-end">
      <div class="alert alert-danger tr-toast-error mb-0 d-flex align-items-center justify-content-start" role="alert" [ngClass]="type">
          <!-- <img class="tr-alert-icon" src="" alt=""> -->
          <img class="tr-alert-icon" src="assets/icons/toast-icons/{{icon}}.svg" alt="">
         <span> {{ message }}  </span>
      </div>
   </div>
</div>